(() => {
  if (customElements.get('lp-zones')) return;

  // Pass ad tracking parameters from the landing page URL on to the product page.
  const passTracking = () => {
    if (document.body.dataset.lpPassUtm !== 'true') return;
    const current = new URLSearchParams(window.location.search);
    const tracked = Array.from(current.entries()).filter(([key]) => /^(utm_|fbclid$|gclid$|ttclid$)/.test(key));
    if (!tracked.length) return;

    document.querySelectorAll('a[data-lp-cta]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      tracked.forEach(([key, value]) => {
        if (!url.searchParams.has(key)) url.searchParams.set(key, value);
      });
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  };

  // Show the mobile discount bar once the visitor has scrolled past the first screen.
  const watchSticky = () => {
    const bar = document.querySelector('[data-lp-sticky]');
    if (!bar) return;
    let ticking = false;

    const update = () => {
      ticking = false;
      bar.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.7);
    };

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    update();
  };

  const init = () => {
    passTracking();
    watchSticky();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', passTracking);

  // Pillow zones: tabs that switch the image and the matching benefits.
  class LpZones extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-lp-zone]');
        if (tab && this.contains(tab)) this.select(tab);
      });

      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-lp-zone]');
        if (!tab || (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')) return;
        const tabs = Array.from(this.querySelectorAll('[data-lp-zone]'));
        const next = tabs[(tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        event.preventDefault();
        this.select(next);
        next.focus();
      });

      this.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-lp-panel]');
        if (!panel) return;
        const tab = this.querySelector(`[aria-controls="${panel.id}"]`);
        if (tab) this.select(tab);
      });
    }

    select(selected) {
      this.querySelectorAll('[data-lp-zone]').forEach((tab) => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });

      this.querySelectorAll('[data-lp-zone-image]').forEach((image) => {
        image.hidden = image.dataset.lpZoneImage !== selected.dataset.lpZone;
      });
    }
  }

  customElements.define('lp-zones', LpZones);
})();
